<ng-container *ngIf="field">
  <div class="flex-auto container-switch input-field-container">
    <label [for]="field.Name" *ngIf="fieldOptions.label">{{ fieldOptions.label }}</label>
	<p-inputSwitch [inputId]="field.Name" [formControl]="control"></p-inputSwitch>
  </div>
</ng-container>
